import { render, staticRenderFns } from "./ApplicationFormCompanyBasic.vue?vue&type=template&id=56beb18b&scoped=true"
import script from "./ApplicationFormCompanyBasic.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormCompanyBasic.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormCompanyBasic.vue?vue&type=style&index=0&id=56beb18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56beb18b",
  null
  
)

export default component.exports